import { useEffect, useState } from "react";
import { AuthProvider } from "./AuthProvider";
import { Loader } from "pixel";
import { AUTH_REDIRECT_URI } from "../../utils/constants";
import { getRealmSpecificAuthorityURL } from "../../utils/utils";
import appConfig from "../../config/appConfig";

interface AuthProviderWrapperProps {
  children: React.ReactNode;
}

interface UserManagerSettings {
  authority: string;
  client_id: string;
}

const AuthProviderWrapper = ({ children }: AuthProviderWrapperProps) => {
  const [userManagerSettings, setUserManagerSettings] = useState<UserManagerSettings | null>(null);

  const realm = localStorage.getItem("realm");
  const authConfig = appConfig?.auth;

  useEffect(() => {
    if (realm && authConfig) {
      const tenantAuthorityURL = getRealmSpecificAuthorityURL(authConfig.realmUrl, realm);
      setUserManagerSettings({
        authority: tenantAuthorityURL,
        client_id: authConfig.client_id,
      });
      return;
    }

    if (authConfig) {
      setUserManagerSettings({
        authority: authConfig.realmUrl,
        client_id: authConfig.client_id,
      });
    }
  }, [authConfig, realm]);

  return (
    <>
      {userManagerSettings ? (
        <AuthProvider
          userManagerSettings={{
            ...userManagerSettings,
            redirect_uri: AUTH_REDIRECT_URI,
            automaticSilentRenew: true,
          }}
        >
          <>{children}</>
        </AuthProvider>
      ) : (
        <Loader variant="fullpage" />
      )}
    </>
  );
};
export default AuthProviderWrapper;
